import { BackLink } from "@/components/BackLink";
import { FaqSection, FinalCtaSection, HowItWorksSection, IncludedSection, VignettesSection } from "@/components/marketing/Sections";
import { useTranslation } from "react-i18next";

import { BRAND } from "@/config/brand";
import { usePageMeta } from "@/lib/seo";

export default function HowItWorks() {
  const { t } = useTranslation();
  usePageMeta({
    title: `${t("nav.howItWorks")} — ${BRAND.name}`,
    description: t("hiw.vignettesSub"),
    localized: true,
  });
  return (
    <div data-testid="how-it-works-page">
      <div className="max-w-[980px] mx-auto px-6 pt-10">
        <BackLink fallback="/" testid="how-back-link" />
      </div>
      <HowItWorksSection HeadingTag="h1" />
      <VignettesSection />
      <IncludedSection />
      <FaqSection />
      <FinalCtaSection />
    </div>
  );
}
